(function(){
  'use strict';

  angular.module('irricrops')


  .factory("seguimientoRes", ['urls', '$resource', function(urls, $resource){
    return $resource(urls.BASE+'/seguimiento/:action', {},{
      gradosDias:{
        method: 'GET',
        params:{
          action: 'grados-dias'
        }
      },
      fenologia:{
        method: 'GET',
        params:{
          action: 'fenologia'
        }
      },
      meses:{
        method: 'GET',
        params:{
          action: 'meses'
        }
      },
      semanas:{
        method: 'GET',
        params:{
          action: 'semanas'
        }
      },
      dias:{
        method: 'GET',
        params:{
          action: 'dias'
        }
      },
    });
  }])
})();
